import Moment from "moment";

export const HdfcMedisureTopupReqBody = (data) => {
  console.log("data from submit HdfcMedisureTopupReqBody", data);

    for (let i = 0; i < data["insureds"].length; i++) {
      let age = data["insureds"][i]["Age"];
      if (
        Number(age) > 45 &&
        data["insureds"][i]["relationShip"] !== "Dependent Parent"
      ) {
        console.log("Hdfc req body contains age > 45", age);
        return null;
      }
    }

  let familyPlanType = "";

  var moment = Moment();
  let year = moment.format("YYYY");
  var currentDate = moment.format("DD/MM/YYYY");

  let countAdult = 0,
    countChild = 0;
  let finalObject = null;
  let individualObject = null; // for HSTPF -> HDFC Medisure Individual
  let familyObject = null; // for HSTPI -> HDFC Medisure Family

  /* Counting the number of adults, children and parents. */
  for (const item of data["insureds"]) {
    if (item.relationShip === "Dependent Child") {
      countChild++;
    } 
    else {
      countAdult++;
    }
  }
  
  /* Checking the number of adults and children and setting the familyPlanType accordingly based on master data (FAMILY_PLAN_MASTER) */
  if (countAdult !== 0 && countChild !== 0) {
    familyPlanType = `${countAdult} ${
      countAdult > 1 ? "Adults" : "Adult"
    } + ${countChild} ${countChild > 1 ? "Children" : "Child"}`;
  } else if (countAdult !== 0 && countChild === 0) {
    familyPlanType = `${countAdult} ${countAdult > 1 ? "Adults" : "Adult"}`;
  }

  /* Creating an object for Individual (HSTPI). */
  individualObject = {
    TransactionID: "",
    Policy_Details: {
      PolicyStartDate: currentDate,
      ProposalDate: currentDate,
      BusinessType_Mandatary: "New Business",
    },
    Req_HSTPI: {
      POLICY_TERM: data["period"],
      Insured_Details: [],
    },
  };

  /* Creating an object for Family (HSTPF). */
  familyObject = {
    TransactionID: "",
    Policy_Details: {
      PolicyStartDate: currentDate,
      ProposalDate: currentDate,
      BusinessType_Mandatary: "New Business",
    },

    Req_HSTPF: {
      POLICY_TERM: data["period"],
      PropRisks_FamilyPolicy_Mandatary: familyPlanType,
      Insured_Details: [],
    },
  };
  
  for (let i = 0; i < data["insureds"].length; i++) {
    
    let relationship = data["insureds"][i]["relationShip"];
   
    let gender = getGender(data, relationship);

    let Date_Of_Birth = data["insureds"][i]["DOB"];
    let dob_year = year - data["insureds"][i]["Age"];
    let dob = null;

    if (Date_Of_Birth === "" || Date_Of_Birth === null) {
      dob = `01/01/${dob_year}`;
    } else {
      dob = Date_Of_Birth;
    }

    // for individual
    individualObject["Req_HSTPI"]["Insured_Details"].push({
      PropRisks_DateOfBirth: dob,
      PropRisks_NameofPerson: data["insureds"][i]["name"],
      PropRisks_Relation: relationship,
      PropRisks_Gender: gender,
      // PropRisks_MaritalStatus: isMarried ? "Married" : "Single",
      PropRisks_SumInsured_Mandatary: data["sumInsuredValue"],
      PropRisks_Deductable: "500000",
    });

    // for family
    familyObject["Req_HSTPF"]["Insured_Details"].push({
      PropRisks_DateOfBirth: dob,
      PropRisks_NameofPerson: data["insureds"][i]["name"],
      PropRisks_Relation: relationship,
      PropRisks_Gender: gender,
      // PropRisks_MaritalStatus: isMarried ? "Married" : "Single",
      PropRisks_SumInsured_Mandatary: data["sumInsuredValue"],
      PropRisks_Deductable: "500000",
    });
  }

  var HSTPI = { HSTPI: individualObject };
  finalObject = { Flag: true, HSTPI: individualObject, HSTPF: familyObject };

  if (data["insureds"].length === 1) {
    return HSTPI;
  }
  return finalObject;
  
};

function getGender(data, relationship) {
  if (relationship === "Spouse") {
    return data.gender === "Male" ? "F" : "M";
  } else if (relationship === "Self") {
    return data.gender.charAt(0);
  } else {
    return "F";
  }
}
